module.exports = __webpack_public_path__ + "img/apple.9b7a20cd.svg";